import { Box, Typography } from "@mui/material";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";

function EmptyState() {
  return (
    <Box
      sx={{
        py: 10,
        textAlign: "center",
      }}
    >
      <LocalFloristIcon
        color="disabled"
        sx={{
          fontSize: 80,
        }}
      />

      <Typography
        variant="h5"
        mt={2}
      >
        No Plants Found
      </Typography>

      <Typography color="text.secondary">
        Try another keyword.
      </Typography>
    </Box>
  );
}

export default EmptyState;